import AutoclickBehaviorAbstract from "../AutoclickBehaviorAbstract";

class AutoclickBehaviorViewableDelay extends AutoclickBehaviorAbstract {
  onViewable() {
    this.delayClickthrough(this.getBehaviorDelay());
  }

  onViewableChange(isViewable) {
    if (!isViewable) {
      clearTimeout(this._autoclick._delayTimer);
    }
  }
}

export default AutoclickBehaviorViewableDelay;



// WEBPACK FOOTER //
// ./src/js/madlib/autoclick/behaviors/AutoclickBehaviorViewableDelayWithReset.js